import { AfterViewInit, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TreeviewItem } from './../../shared/TreePermissions/treeview-item';
import { TreeviewConfig } from './../../shared/TreePermissions/treeview-config';
import { PermissionsService } from './../../shared/services/permissions.service';
import { PermissionspopupComponent } from "./permissionspopup/permissionspopup.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TrnxCommonService } from "src/app/shared/services/trnx-common.service";
import { ScreenCreatorTransactionService } from "src/app/shared/services/screen-creator-transaction.service";
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { TreeNode } from 'primeng/api';
/*
   @Author:Ravi G
   @Date:28-06-2022
*/
@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    providers: [
        PermissionsService
    ],
    standalone: false
})
export class PermissionsComponent implements OnInit,AfterViewInit {

  // config = TreeviewConfig.create({
  //   hasAllCheckBox: true,
  //   hasFilter: true,
  //   hasCollapseExpand: true,
  //   decoupleChildFromParent: false,
  //    useItemClass: true ,
  // })as any;


  public permissions = { userId: "", userName: "" };
  public formValid: UntypedFormGroup;
  public townshipMasterDetails: any = [];
  public residentDetails: any = [];
  public userNamesDetails: any = [];
  public townshipId;
  public residentType;
  public responseEmpData: any = [];
  public selectedUserId = 0;
  public selectedUserName = "";
  public screenType;
  public permissionNamesWeb;
  public permissionNamebuttons;
  public havingPermissionAccess = [];
  public permissionNamesMobile;
  public mobileWeb = false;
  // public items: TreeviewItem[];
  public items: TreeNode[];
  public selectedNodes: TreeNode[] = [];
  // public rawItems:TreeviewItem[]
  // public itemsMobile: TreeviewItem[];
  public validation_messages;
  public parentIdsMobile;
  public parentIdsWeb;
  //public adminChecked=false;
  public selectedUserType;
   private classesApplied = false; 
  usersObject: any = [];
   dnsid:number;
  importExportTableName = "accesspermission";
  backgroundColorButton: any;
  finalButtonPermissions:any[] = []
  showLegend: boolean = false;
  mappingTypeDataDropDown :any =[]
 criticalOpMap = new Map<string, string>();
//  @ViewChild('tree') tree!: any; // References the Template p-tree component instance
 // Explicitly type it as 'any' to bypass template type-checking constraints
@ViewChild('tree') treeComponent!: any;
public isAllSelected: boolean = false; // Binds checked matrix indicator
public isTreeExpanded: boolean = false;
originalItems: TreeNode[] = [];
ngAfterViewInit() {
  console.log('Tree Component', this.treeComponent);
}
 retrievePermissionAccess(screenType) {

    console.log("retrievePermissionAccess(screenType)");

    console.log("this.selectedUserId");


    //additional parameter
    //this.havingPermissionAccess[0].rolename=this.selectedUserName;
    
    const distinctAccessPermissions = this.havingPermissionAccess.filter(
    (item, index, self) =>
        index === self.findIndex(t => JSON.stringify(t) === JSON.stringify(item))
    );

   console.log("Distinct access permissions:", distinctAccessPermissions);
   
    

    console.log(this.selectedUserId);

    this.spinner.start();

    this.permissionsService.insertPermissionAccess(distinctAccessPermissions, screenType, this.selectedUserId).subscribe(response => {
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
        this.spinner.stop();
      }
      else {
        this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });

        if (screenType == 'web') {
          this.retrieveWeb();
          //window.location.reload()
        }
        this.spinner.stop();
      }
    })

    this.permissionsService.insertIntoScreenOperationPermission(this.permissionNamebuttons).subscribe(res=> {
      if (res.error != true) {
        console.log("success")
      }
    })


  }

  async retrieveWeb() {

    this.spinner.start();
    console.log('selectedUserId');
    console.log(this.selectedUserId);
    /*
     Modifed :Chandra R
     Here Both screen permissions and Buttons permissions are updating
    */
    let response = await this.permissionsService.retrievePermissionNamesService("web", this.selectedUserId);
    let res = await this.permissionsService.retrievesubchildPermissionNamesService(this.selectedUserId);
    console.log(res);
    console.log(response);

    await this.retrieveWebPermissions(response,res,this.selectedUserId);

  }

  constructor(private permissionsService: PermissionsService, private spinner: NgxUiLoaderService, private dialog: MatDialog, private snackbar: MatSnackBar, private errorMessages: ErrorMessages, private trnxService: TrnxCommonService, private trnxScreenCreatorService: ScreenCreatorTransactionService,private ngZone: NgZone,private commonService:CommonService,private localStorage: LocalStorageSettingsService) {
    //messages for validations
    this.validation_messages = this.errorMessages.permissionsMessage;
  }

  async ngOnInit() {
     this.backgroundColorButton = this.localStorage.getSettings("ColorA");

    this.formValidations();
     this.commonService
    .getlookupVauleByLookUpType("critical operation type")
    .subscribe(result => {
      this.mappingTypeDataDropDown = result;
      this.buildCriticalOpMap();   // ⭐ IMPORTANT
    });
    this.usersObject = await this.trnxService.retrieveTrnxService("userrolesmstr", 0);

    console.log(this.usersObject);

  }

  formValidations() {
    this.formValid = new UntypedFormGroup({
      userId: new UntypedFormControl(this.permissions.userId, [Validators.required]),
      userName: new UntypedFormControl(this.permissions.userName, [Validators.required]),
    });
  }

  async openDetailsDialog() {
    
    console.log("openDetailsDialog()");

    this.spinner.start();

    console.log("this.selectedUserId");

    console.log(this.selectedUserId);

    if (this.selectedUserId > 0) {

      //To get index of json, in which json the selected value is present.
      let indexTemporary = this.usersObject.findIndex(jsonObjectTemp => jsonObjectTemp["userid"] == this.selectedUserId);

      console.log(indexTemporary);

      console.log(this.usersObject[indexTemporary]);

    }

    console.log("this.usersObject");

    console.log(this.usersObject);

    let trnxRetrieveTableData: any = [];

    trnxRetrieveTableData = await this.trnxScreenCreatorService.retrieveTrnxScreenByTableNameService("userrolesmstr");

    let trnxDynamicData = JSON.parse(trnxRetrieveTableData.tableDetails).tableData;

    console.log(trnxDynamicData);

    this.spinner.stop();

    if ((this.usersObject != null) && (this.usersObject != undefined)) {

      let dialogRef = this.dialog.open(PermissionspopupComponent, {
        maxWidth: '100vw',
        height: "95%",
        width: "80%",
        data: { "dynamicData": trnxDynamicData, "usersObject": this.usersObject },
        disableClose: true
      });

      // subcribe the popup after close
      dialogRef.afterClosed().subscribe(async result => {

        console.log(result);

        if (result[0].status != "No") {

          this.selectedUserName = result[0].rolename

          this.selectedUserId = result[0].userrolesmstrid;

          console.log("this.selectedUserId");

          console.log(this.selectedUserId);

          await this.retrieveWeb();

          this.selectedUserType = result[0].userType;

          this.mobileWeb = true;

        }

        else {

          this.snackbar.open("Please select record, which has status 'yes'.", "Ok", { duration: 5000 });

        }

      });

    }

  }

  changeTownship(event) {
    this.userNamesDetails = "";
    this.selectedUserId = 0;
    this.selectedUserName = "";
    this.formValid.controls.userId.setValue(null);
  }

  changeResident(event) {
    this.userNamesDetails = "";
    this.selectedUserId = 0;
    this.selectedUserName = "";
  }

  // insert permission access
 sendData( screenType) {
   
    const screenIds = this.selectedNodes.map(node => node.key);
     console.log(screenIds);
     console.log("selectedNodes length", this.selectedNodes.length);

console.log("first node", this.selectedNodes[0]);

console.log(
  this.selectedNodes.map(x => ({
    label: x.label,
    key: x.key
  }))
);
    if (screenType == "web") {
      var parentWeb = [];
      var childrenWeb = [];
      var childrenWebAnother = [];
      var anotherParentWeb = [];
      var childbutton = [];
      var list= [];
      //Storing the level 1 into anotherParentMobile level 2 into childrenMobile.


      for (var l = 0; l < this.permissionNamesWeb.length; l++) {
        if (this.permissionNamesWeb[l].level == 1) {
          anotherParentWeb.push(this.permissionNamesWeb[l]);
        }
        else {
          childrenWeb.push(this.permissionNamesWeb[l]);
        }
      }
      var allAccess;
      //Storing the parents into anotherParentMobile which does not have screenId 1002.
      for (let p = 0; p < anotherParentWeb.length; p++) {
        if (anotherParentWeb[p].screenId == 1001) {

        }
        else {
          parentWeb.push(anotherParentWeb[p]);
        }
      }

      

      console.log(screenIds);
        
      //Storing children in childrenMobileAnother which has checked.
      for (var o = 0; o < screenIds.length; o++) {
        
        
        /*
        Modified by: Chandra R
        while retriving the data from updated we are segrigating the buttons and screens 
        */
        if (typeof screenIds[o] === 'string' && screenIds[o].startsWith('Btn')) {
          list.push(screenIds[o]); // Append to list if it's a string and contains "Btn"
          screenIds.splice(o, 1); // Remove the element at index o
          o--; // Adjust index to account for the removed element
        }
        
      }
      console.log(screenIds);
      console.log(this.permissionNamebuttons)
      const normalizedList = list.map(item => item.split('|')[0]);
      console.log(normalizedList)
      
        
      for (var p = 0; p < this.permissionNamebuttons.length; p++) {
        var buttonName = "Btn" + this.permissionNamebuttons[p].buttonId +"+"+this.permissionNamebuttons[p].screenid;
          if(buttonName === "Btn128+1134"){
              
          }
        // Check if the button name is not in the list
        if (!normalizedList.includes(buttonName)) {
            console.log(buttonName + " not in list");
            var selectedUserId = this.selectedUserId;
            selectedUserId.toString();
            if(this.permissionNamebuttons[p].roleid != null){
              // Get the current roleid
            var tempVariable = this.permissionNamebuttons[p].roleid;
            // Remove selectedUserId from roleid
            var updatedRoleId = tempVariable
                .split(",") // Split into an array
                .filter(function(id) {
                    return id.trim() !== selectedUserId.toString(); 
                })
                .join(","); // Join back into a string


                // Update roleid
            this.permissionNamebuttons[p].roleid = updatedRoleId;
            console.log("Updated roleid: " + this.permissionNamebuttons[p].roleid);
            // Log updated roleid

            }
            
        }else{
          let selectedUserId = this.selectedUserId.toString();
          if(this.permissionNamebuttons[p].roleid != null){
          var roleIds = this.permissionNamebuttons[p].roleid.split(",");
          if (!roleIds.includes(selectedUserId)) {
            // Add selectedUserId to roleid
            this.permissionNamebuttons[p].roleid += `,${selectedUserId}`;
            console.log("Added selectedUserId to roleid: " + this.permissionNamebuttons[p].roleid);
            } else {
            console.log("selectedUserId is already in roleid");
           }
          }
          else{
            this.permissionNamebuttons[p].roleid += `,${selectedUserId}`;
            console.log("Added selectedUserId to roleid: " + this.permissionNamebuttons[p].roleid);

          }
         

          
        }
        // Log the entire permissionNamebuttons array for verification
        console.log(this.permissionNamebuttons);
      }

      
      console.log(list);
      console.log(parentWeb)
      
      
      //Based on condition store Yes in allAccess.
      for (let q = 0; q < anotherParentWeb.length; q++) {
        if (anotherParentWeb[q].screenId == 1001) {
          if (screenIds.length == (parentWeb.length + childrenWeb.length)) {
            allAccess = 'Yes';
          }
        }
      }
      console.log(screenIds);
      if (allAccess == 'Yes') {
        this.havingPermissionAccess = [];
        this.havingPermissionAccess.push({ screenId: 1001, userId: this.selectedUserId });
        console.log(this.havingPermissionAccess);
        this.retrievePermissionAccess(screenType);
      }
      else if (screenIds.length != 0) {
        this.havingPermissionAccess = [];
        for (var i = 0; i < screenIds.length; i++) {
          if(Number(screenIds[i] )!= 1001){
          this.havingPermissionAccess.push({ screenId: screenIds[i], userId: this.selectedUserId });
          }
        }
        this.retrievePermissionAccess(screenType);
      }
      else {
        this.havingPermissionAccess = [];
        //For checking the access of the screens yes or no.
        var r = 0;
        for (let q = 0; q < this.permissionNamesWeb.length; q++) {
          if (this.permissionNamesWeb[q].access == 'Yes') {
            r += 1;
            break;
          }
        }
        if (r > 0) {
          if (confirm("Are you sure you want to remove all permissions of screens ?") == true) {
            this.retrievePermissionAccess(screenType);
          }
        }
        else {
          this.snackbar.open("Please select atleast one checkbox", "OK", { duration: 5000 });
        }
      }
      console.log(this.havingPermissionAccess);
    }
  }

  async retrieveWebPermissions(response,res,roleid) {
    

    console.log("retrieveWebPermissions()");

    console.log(response);
    console.log(res);

    if (response.error == true) {

      console.log("if");

      console.log(response);

      this.parentIdsWeb = [];

      this.spinner.stop();

       this.showLegend = false;
    }

    else {
      console.log("else");

      console.log(response);

      this.parentIdsWeb = [];

      this.permissionNamesWeb = response;

      this.permissionNamebuttons = res;
       this.checkCriticalOperations(res);
      console.log('permissionNamesWeb')
      console.log(this.permissionNamesWeb);
      console.log('permissionNamebuttons')
      console.log(this.permissionNamebuttons)
      this.permissionNamebuttons = res.map(btn => {
      const meta = this.resolveCriticalMeta(btn.criticaloperation);
      return {
        ...btn,
        _cssClass: meta.cssClass,
        _icon: meta.icon,
        _tooltip: meta.tooltip
      };
    });

      // this.rawItems = this.permissionsService.getPermissions(this.permissionNamesWeb, this.permissionNamebuttons,"Web",roleid);
      
      // console.log("this.items");
      //  console.log('Treeview items structure:', JSON.stringify(this.rawItems, null, 2));
      //  this.items = this.rawItems.map(item => this.propagateItemClass(item));
      this.items = this.permissionsService.getPermissions(
  this.permissionNamesWeb,
  this.permissionNamebuttons,
  'Web',
  roleid
);
      console.log(this.items);
      this.originalItems = structuredClone(this.items);
      const adminNode = this.items.find(
  n => n.label === 'Administration'
);

console.log('Admin Node');
console.log(adminNode);

console.log('Admin Node Data');
console.log(adminNode?.data);

console.log('Admin Node Children');
console.log(adminNode?.children);
      console.log(
  this.items[0].children?.[0]
);
//       console.log(
//   this.items[0].children[0].parent
// );
      // console.log(JSON.stringify(this.items, null, 2));
      // console.log(JSON.stringify(this.items[0], null, 2));
      this.items.forEach(node => {
  this.updatePartialState(node);
});
      this.selectedNodes = this.buildSelectedNodes(this.items);
      const totalNodes = this.countAllNodes(this.items);

this.isAllSelected =
  this.selectedNodes.length === totalNodes;

console.log('Selected Nodes');
console.log(this.selectedNodes);
console.log('selectedNodes count', this.selectedNodes.length);
console.log(
  this.selectedNodes.map(n => ({
    label: n.label,
    key: n.key,
    checked: n.data?.checked
  }))
);
this.selectedNodes.forEach(node => {
  console.log(node.label, node.key);
});
      // console.log(this.config);
      // setTimeout(() => this.applyPermissionClasses(), 50);
// this.applyPermissionClasses();  
      this.spinner.stop();
    // setTimeout(() => {
    //   this.startTreeObserver()
    //  this.items.forEach(item => this.applyClassToDom(item));
    // });


    }

  }
 

  checkCriticalOperations(apiResponse: any[]) {
  if (!apiResponse || !Array.isArray(apiResponse)) {
    this.showLegend = false;
    return;
  }
  
  // Check if any item has criticaloperation = true
 const hasCriticalOperations = apiResponse.some(item => item.criticaloperation === true || item.criticaloperation === 'true');

  const hasStandardOperations = apiResponse.some(item => item.criticaloperation === false || item.criticaloperation === false ||item.criticaloperation === null);
  
  // Show legend only if we have operations with criticaloperation field
  this.showLegend = hasCriticalOperations || hasStandardOperations;
  
  if (this.showLegend) {
    console.log('Legend will be shown. Critical operations present:', hasCriticalOperations);
  }
}


 
buildCriticalOpMap() {
  this.mappingTypeDataDropDown.forEach(item => {
    this.criticalOpMap.set(
      item.lookupcode,          // "1"
      item.lookupvalue.toLowerCase() // "re-authentication"
    );
  });
}
private resolveCriticalMeta(code: any) {

  if (!code) {
    return {
      cssClass: 'standard-permission',
      icon: '',
      tooltip: 'Standard operation'
    };
  }

  const type = this.criticalOpMap.get(String(code));

  if (!type) {
    return {
      cssClass: 'standard-permission',
      icon: '',
      tooltip: 'Standard operation'
    };
  }

  if (type === 'digital signature') {
    return {
      cssClass: 'critical-permission',
      icon: '⛔ ',
      tooltip: 'Digital signature required'
    };
  }

  if (type === 're-authentication') {
    return {
      cssClass: 'reauth-permission',
      icon: '🛡️ ',
      tooltip: 'Re-authentication required'
    };
  }

  return {
    cssClass: 'standard-permission',
    icon: '',
    tooltip: 'Standard operation'
  };
}



            /*
      * Author: Sujeet Sharma
      * Date: 26-12-2025
      *
      * Description:
      * Enhanced Import/Export functionality to support Administration-level
      */
   importData() {
       
          console.log("<--- Inside upload Group Template --->")
          let width = "85%";
        let dialogRef = this.dialog.open(ImportJsonComponent, {
            maxWidth: "70vw",
            height: "50%",
            width: width,
          data: { "tablename": this.importExportTableName, "tenantid": this.dnsid },
            disableClose: true,
          });
        
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
        console.log("tenantid");
            //this.reportCreationData = result;
        
            //this.vaultObjectService.retrieveobjectgroup();
          });
        
        
      }
      
    
      async exportData() {
        this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
        let tenantid = localStorage.getItem("dnsName")
       
    
          try {
            const blob = await this.commonService.downloadJsonFile(this.importExportTableName, this.dnsid+"");
            const link = document.createElement('a');
            const timestamp = new Date().getTime();
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.importExportTableName}_export_${timestamp}.json`;
            link.click();
            window.URL.revokeObjectURL(link.href);
    
          } catch (error) {
            console.error('Error downloading JSON:', error);
          }
        
        
      }

      extractSelectedValues() {

  const values: any[] = [];

  const traverse = (nodes: TreeNode[]) => {

    nodes.forEach(node => {

      if (node.partialSelected || node.expanded || node.selectable) {
        values.push(node.key);
      }

      if (node.children?.length) {
        traverse(node.children);
      }
    });
  };

  traverse(this.selectedNodes);

  return values;
}

// 1. Expand All Dynamic Subtree Elements Recursively
expandAll() {
  if (this.items) {
    this.items.forEach(node => {
      this.expandRecursive(node, true);
    });
    this.items = [...this.items]; // Destructure trigger sequence to refresh PrimeNG state layout
  }
}

// 2. Collapse All Subtree Elements Recursively
collapseAll() {
  if (this.items) {
    this.items.forEach(node => {
      this.expandRecursive(node, false);
    });
    this.items = [...this.items]; // Destructure trigger sequence to refresh PrimeNG state layout
  }
}


toggleSelectAll(checked: boolean) {

  if (!this.items) {
    return;
  }

  this.setNodeSelection(this.items, checked);

  this.selectedNodes = [];

  if (checked) {

    const collectNodes = (nodes: TreeNode[]) => {

      nodes.forEach(node => {

        this.selectedNodes.push(node);

        if (node.children?.length) {
          collectNodes(node.children);
        }

      });

    };

    collectNodes(this.items);

  }

  this.items = [...this.items];
}

private setNodeSelection(
  nodes: TreeNode[],
  checked: boolean
) {
  nodes.forEach(node => {

    node.data = node.data || {};

    node.data.checked = checked;

    node.partialSelected = false;

    if (node.children?.length) {
      this.setNodeSelection(
        node.children,
        checked
      );
    }
  });
}

onSelectionChange(event: TreeNode[]) {

  this.selectedNodes = event;

  event.forEach(node => {

    if (node.children?.length) {

      node.partialSelected = false;

      node.data = node.data || {};
      node.data.checked = true;

      let parent = node.parent;

      while (parent) {

        parent.partialSelected = false;

        parent.data = parent.data || {};
        parent.data.checked = true;

        parent = parent.parent;
      }
    }
  });
   const totalNodes =
    this.countAllNodes(this.items);

  this.isAllSelected =
    this.selectedNodes.length === totalNodes;
}
private selectAllChildren(node: TreeNode) {

  if (!node.children) {
    return;
  }

  node.children.forEach(child => {

    child.data = child.data || {};
    child.data.checked = true;
    child.partialSelected = false;

    if (!this.selectedNodes.includes(child)) {
      this.selectedNodes.push(child);
    }

    this.selectAllChildren(child);
  });
}

private countAllNodes(nodes: TreeNode[]): number {
  let count = 0;
  if (nodes) {
    nodes.forEach(node => {
      count++;
      if (node.children) {
        count += this.countAllNodes(node.children);
      }
    });
  }
  return count;
}


onTreeFilter(event: Event) {
  const query = (event.target as HTMLInputElement)
    .value
    .toLowerCase();

  if (!query) {
    this.items = structuredClone(this.originalItems);
    return;
  }

  this.items = this.filterNodes(
    structuredClone(this.originalItems),
    query
  );
}

private filterNodes(
  nodes: TreeNode[],
  searchText: string
): TreeNode[] {

  return nodes
    .map(node => {
      const children = node.children
        ? this.filterNodes(node.children, searchText)
        : [];

      const matches =
        node.label
          ?.toLowerCase()
          .includes(searchText);

      if (matches || children.length) {
        return {
          ...node,
          expanded: true,
          children
        };
      }

      return null;
    })
    .filter(Boolean) as TreeNode[];
}

toggleGlobalTreeExpansion() {
    console.log('Expand/Collapse clicked');
      console.log('items=', this.items);
    
  this.isTreeExpanded = !this.isTreeExpanded;
   console.log('isTreeExpanded=', this.isTreeExpanded);

  if (this.items && this.items.length > 0) {
    this.items.forEach(node => {
      this.expandRecursive(node, this.isTreeExpanded);
    });
     console.log('Root node expanded=', this.items[0].expanded);

    console.log(
      'First child expanded=',
      this.items[0]?.children?.[0]?.expanded
    );
   
    this.items.forEach(node => {
  this.expandRecursive(node, this.isTreeExpanded);
});
    this.items = structuredClone(this.items);
  }
}

private expandRecursive(node: any, isExpand: boolean) {
  node.expanded = isExpand;
  if (node.children && node.children.length > 0) {
    node.children.forEach((childNode: any) => {
      this.expandRecursive(childNode, isExpand);
    });
  }
}


private buildSelectedNodes(nodes: TreeNode[]): TreeNode[] {
  const selected: TreeNode[] = [];

  const hasCheckedDescendant = (node: TreeNode): boolean => {

    if (node.data?.checked === true) {
      return true;
    }

    if (node.children?.length) {
      return node.children.some(child =>
        hasCheckedDescendant(child)
      );
    }

    return false;
  };

  const traverse = (treeNodes: TreeNode[]) => {

    treeNodes.forEach(node => {

      if (hasCheckedDescendant(node)) {
        selected.push(node);
      }

      if (node.children?.length) {
        traverse(node.children);
      }
    });
  };

  traverse(nodes);

  return [...new Set(selected)];
}

private updatePartialState(node: TreeNode): void {

  if (!node.children || node.children.length === 0) {
    return;
  }

  node.children.forEach(child => {
    this.updatePartialState(child);
  });

  const selectedCount =
    node.children.filter(
      child =>
        child.data?.checked === true ||
        child.partialSelected === true
    ).length;

  if (selectedCount === 0) {

    node.partialSelected = false;
    node.data.checked = false;

  }
  else if (selectedCount === node.children.length) {

    node.partialSelected = false;
    node.data.checked = true;

  }
  else {

    node.partialSelected = true;
    node.data.checked = false;

  }
}
} 
